module.exports = __webpack_public_path__ + "img/20200402113444198.fbbc6f3e.png";